// extracted by mini-css-extract-plugin
module.exports = {"pointer":"ResultScreen_pointer__2s8-Y","hints":"ResultScreen_hints__-bYzo","itemHint":"ResultScreen_itemHint__32r2E","issue":"ResultScreen_issue__eSWKU"};